import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    SCHEDULE_REPORTS: "api/schedulereports"
}

const getScheduleReports = async (): Promise<any> => {
    const response = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.SCHEDULE_REPORTS}`);
    return response.data;
}

const addScheduleReports = async (payload: any): Promise<any> => {
    const response = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.SCHEDULE_REPORTS, payload);
    return response.data;
}

const updateScheduleReport = async (id: number, payload: any): Promise<any> => {
    const response = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.SCHEDULE_REPORTS}/${id}`, payload);
    return response.data;
}

const ScheduleReports = {
    getScheduleReports,
    addScheduleReports,
    updateScheduleReport,
}

export default ScheduleReports